import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { IdentityProvider } from './contexts/IdentityContext';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { Toaster } from 'sonner';
import BottomNav from './components/BottomNav';
import CookieConsent from './components/CookieConsent';
import LandingPage from './pages/LandingPage';
import HomePage from './pages/HomePage';
import BiblePage from './pages/BiblePage';
import SearchPage from './pages/SearchPage';
import ProfilePage from './pages/ProfilePage';
import MessagesPage from './pages/MessagesPage';
import PreachingPage from './pages/PreachingPage';
import './App.css';

function AppContent() {
  return (
    <div className="min-h-screen bg-background noise-overlay">
      <main className="relative z-10 max-w-lg mx-auto pb-20">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/bible" element={<BiblePage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/preaching" element={<PreachingPage />} />
          <Route path="/messages" element={<MessagesPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <BottomNav />
      <CookieConsent />
      <Toaster
        position="top-center"
        toastOptions={{
          className: 'font-[var(--font-body)] text-sm',
          duration: 3000,
        }}
      />
    </div>
  );
}

function App() {
  return (
    <Router>
      <ThemeProvider>
        <LanguageProvider>
          <IdentityProvider>
            <AuthProvider>
              <NotificationProvider>
                <AppContent />
              </NotificationProvider>
            </AuthProvider>
          </IdentityProvider>
        </LanguageProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
